export default [
    {
		path: '/log',
		name: 'Activity Log',
		component: () => import('@/views/team/ActivityLog.vue'),
		meta: {
			layout: 'Default',
			abilities: [
                ['view', 'workspace-content'],
                ['view', 'ugc-content'],
              ]
		}
	},
]